import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { AppRoutes } from "./AppRoutes";
import { SpeedInsights } from "@vercel/speed-insights/react";
import { Analytics } from "@vercel/analytics/react";
import { RecoilRoot } from "recoil";
import { useEffect } from "react";
import { validateAppCache } from "@/utils/cacheManager";


const App = () => {
  // Validate app cache on initial load
  useEffect(() => {
    validateAppCache();
  }, []);

  return (
    <RecoilRoot>
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
              <TooltipProvider>
                <Toaster />
                <Sonner />
                <SpeedInsights />
                <AppRoutes />
                <Analytics />
              </TooltipProvider>
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </RecoilRoot>
  );
};

export default App;